import { render, staticRenderFns } from "./politicsProjectManage.vue?vue&type=template&id=b13db73e&scoped=true"
import script from "./politicsProjectManage.vue?vue&type=script&lang=js"
export * from "./politicsProjectManage.vue?vue&type=script&lang=js"
import style0 from "./politicsProjectManage.vue?vue&type=style&index=0&id=b13db73e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13db73e",
  null
  
)

export default component.exports